import { ThemeProvider } from "styled-components";
import { AutoagendamientoV2Styles } from "../../theme/AutoagendamientoV2Styles";
import HeaderTop from "../../components/autoagendamientov2/HeaderTop";
import { Row, Col, Modal } from "react-bootstrap";
import AutoagendmientoFooter from "../../components/autoagendamientov2/AutoagendmientoFooter";
import useTheme from "../../hook/useTheme";
import Loading from "../../components/autoagendamientov2/Loading";
import CardDinamic from "../../components/autoagendamientov2/CardDinamic";
import { useState } from "react";
import OnCitaV2 from "../../components/videoconferenciav2/OnCitaV2";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { getTokenExternal } from "../../utils/getTokenExternal";
import Get from "../../api/Get";
import {
  GET_APPOINTMENT_BY_ID,
  UPDATE_APPOINTMENT_SIN_TOKEN,
} from "../../api/Routes";
import { compareDate } from "../../utils/compareDate";
import moment from "moment";
import OnCitaConcluidov2 from "../../components/videoconferenciav2/OnCitaConcluidov2";
import { getTimeParam } from "../../utils/getTimeParam";
import OnCitaNoComienzaDiferentDayV2 from "../../components/videoconferenciav2/OnCitaNoComienzaDiferentDayV2";
import OnCitaNoComienzaV2 from "../../components/videoconferenciav2/OnCitaNoComienzaV2";
import WaitOnDemandV2 from "../../components/videoconferenciav2/WaitOnDemandV2";
import Put from "../../api/Put";
import SurveyV2 from "../../components/videoconferenciav2/SurveyV2";
import AutoagendamientoOnDemandV2 from "../../components/videoconferenciav2/AutoagendamientoOnDemandV2";
import { setTimeAppointmentSinToken } from "../../utils/setTimeAppointmentSinToken";
import Banner1 from "../../components/autoagendamientov2/Banner1";
import PendiengLegalWarningV2 from "../../components/videoconferenciav2/PendiengLegalWarningV2";
import { getIpPublic } from "../../utils/getIpPublic";

function ClbConferencia() {
  const { id } = useParams();
  const { theme } = useTheme("defaultv2");
  const [currentScreen, setCurrentScreen] = useState("loading");
  const [recheck, setRecheck] = useState(true);
  const [items, setItems] = useState({
    cita: null,
    statusMessage: "",
    waitMessage: "",
    legalWarning: null,
    openConfirmacionDeclinar: false,
    isProcessRequest: false,
  });

  //ondemand data
  const [ondemandWait1, setOndemandWait1] = useState(-1);
  const [ondemandWait2, setOndemandWait2] = useState(-1);
  //controlar timeOUT
  const [checkFiveSeconds, setCheckFiveSeconds] = useState(false);
  //encuestaModal
  const [openEncuesta, setOpenencuesta] = useState(false);
  //control dialog for survey and control api service para cdo empieza y cdo se acaba la cita
  const [hangUp, setHangUp] = useState(false);
  const [startMet, setStartMet] = useState(false);
  //content es para el consntimiento configurado
  const [content, setContent] = useState("");

  useEffect(() => {
    const fetchApi = async () => {
      try {
        const responseToken = await getTokenExternal({ id: 2 });
        const token = responseToken.data.access_token;

        const response = await Get({
          url: `${GET_APPOINTMENT_BY_ID}/${atob(id)}`,
          access_token: token,
        });
        if (response.data.state) {
          let current_cita = response.data.data;
          setItems((prev) => ({
            ...prev,
            cita: current_cita,
          }));

          let afterBefore = compareDate(
            current_cita.currentTime,
            current_cita.scheduleDTO.dateTimeEnd
          );
          let fechaInit = compareDate(
            current_cita.currentTime,
            current_cita.scheduleDTO.dateTimeInit
          );
          let sameDay =
            moment(current_cita.currentTime, "DD/MM/YYYY HH:mm:ss").format(
              "DD-MM-YYYY"
            ) ===
            moment(
              current_cita.scheduleDTO.dateTimeInit,
              "YYYY-MM-DDTHH:mm:ss"
            ).format("DD-MM-YYYY");

          //checar consentimiento informado
          let legalWarning = current_cita.legalWarnings.filter(
            (el) => el.legalWarningType === "InformedConsent"
          );

          if (
            legalWarning.length > 0 &&
            legalWarning[0]?.acceptPatient === "declined"
          ) {
            setItems((prev) => ({
              ...prev,
              legalWarning: legalWarning[0],
            }));
            setCurrentScreen("declinadoLegalWarning");
          } else if (
            legalWarning.length > 0 &&
            legalWarning[0]?.acceptPatient === "pending"
          ) {
            setItems((prev) => ({
              ...prev,
              legalWarning: legalWarning[0],
            }));
            setCurrentScreen("pendingLegalWarning");
          } else if (current_cita.appointmentStatus === "Pendiente") {
            setItems((prev) => ({
              ...prev,
              statusMessage: "Su cita se encuentra pendiente de aprobación",
            }));
            setCurrentScreen("statusCita");
          } else if (current_cita.appointmentStatus === "Cancelada") {
            setItems((prev) => ({
              ...prev,
              statusMessage: "Su cita ha sido cancelada.",
            }));
            setCurrentScreen("statusCita");
          } else if (current_cita.appointmentStatus === "Fallida") {
            setItems((prev) => ({
              ...prev,
              statusMessage: "Cita fallida.",
            }));
            setCurrentScreen("statusCita");
          } else if (
            current_cita.appointmentStatus === "NoAtendida" ||
            (afterBefore === "terminado" &&
              current_cita.dataVideoCallList.length === 0)
          ) {
            setItems((prev) => ({
              ...prev,
              statusMessage: "Su cita no ha sido atendida.",
            }));
            setCurrentScreen("statusCita");
          } else if (current_cita.finished || afterBefore === "terminado") {
            setCurrentScreen("citaConcluido");
          } else if (
            current_cita.scheduleDTO.scheduleType.id === "OnDemand" &&
            fechaInit === "noTerminado"
          ) {
            let firstW = getTimeParam(current_cita.hourSettings.firstWait, "s");
            let secW = getTimeParam(current_cita.hourSettings.secondWait, "s");
            if (firstW > 0) {
              setItems((prev) => ({
                ...prev,
                waitMessage: "Espere a que su médico se conecte",
              }));
              setOndemandWait1(firstW);
              setCurrentScreen("firstWait");
            } else if (secW > 0) {
              setItems((prev) => ({
                ...prev,
                waitMessage:
                  "El tiempo de espera para el médico asignado se ha agotado",
              }));
              setOndemandWait2(secW);
              setCurrentScreen("secondWait");
            } else {
              setItems((prev) => ({
                ...prev,
                waitMessage: "El médico no puede conectarse",
              }));
              setCurrentScreen("demandMedicoNoConectado");
            }
          } else if (fechaInit === "noTerminado" && sameDay) {
            setCurrentScreen("citaNoComienza");
          } else if (fechaInit === "noTerminado" && !sameDay) {
            setCurrentScreen("citaNoComienzaDiferentDay");
          } else if (current_cita.finished || afterBefore === "terminado") {
            setCurrentScreen("citaConcluido");
          } else {
            setCurrentScreen("enCita");
          }
        }
      } catch (error) {
        setCurrentScreen("errorComunication");
      }
    };
    if (recheck) {
      fetchApi();
      setRecheck(false);
    }
  }, [id, recheck]);

  //efecto para controlad ondemandWait1
  useEffect(() => {
    if (ondemandWait1 >= 0) {
      const interval = setInterval(() => {
        setOndemandWait1(ondemandWait1 - 1);
      }, 1000);
      if (ondemandWait1 === 0) {
        setCheckFiveSeconds(true);
      }
      return () => clearInterval(interval);
    }
  }, [ondemandWait1]);
  //efecto para esperar 5 segundos por el socket
  useEffect(() => {
    if (checkFiveSeconds) {
      const t = setTimeout(() => {
        setOndemandWait1(-1);
        setItems((prev) => ({
          ...prev,
          waitMessage:
            "El tiempo de espera para el médico asignado se ha agotado",
        }));
        setCurrentScreen("secondWait");
      }, 10000);
      return () => clearTimeout(t);
    }
  }, [checkFiveSeconds]);
  //efecto para controlad ondemand secondtWait
  useEffect(() => {
    if (ondemandWait2 >= 0 && ondemandWait1 === -2) {
      const interval = setInterval(() => {
        setOndemandWait2(ondemandWait2 - 1);
      }, 1000);
      if (ondemandWait2 === 0) {
        setCurrentScreen("demandMedicoNoConectado");
        setOndemandWait2(-1);
        //update appointement a noatended
        let data = {
          id: items.cita.id,
          appointmentStatus: "NoAtendida",
        };
        const putRequest = async () => {
          try {
            await Put({
              url: UPDATE_APPOINTMENT_SIN_TOKEN,
              data: data,
              header: false,
            });
          } catch (error) {
            console.log(error);
          }
        };
        putRequest();
      }
      return () => clearInterval(interval);
    }
  }, [ondemandWait2, ondemandWait1, items.cita?.id]);

  //effecto para cuando cualga la llamada
  useEffect(() => {
    if (hangUp) {
      setTimeAppointmentSinToken(
        items.cita.id,
        "Patient",
        false,
        items.cita.dataVideoCallList
      );
      setHangUp(false);
    }
  }, [hangUp, items.cita?.id, items.cita?.dataVideoCallList]);

  //effecto para cuando empieza la llamada
  useEffect(() => {
    if (startMet) {
      setTimeAppointmentSinToken(
        items.cita.id,
        "Patient",
        true,
        items.cita.dataVideoCallList
      );
      setStartMet(false);
    }
  }, [startMet, items.cita?.id, items.cita?.dataVideoCallList]);

  const onApiReady = (externalApi) => {
    externalApi.addEventListener("videoConferenceJoined", () => {
      if (items.cita.patientDTO.account.allowRecord) {
        externalApi.executeCommand("startRecording", { mode: `file` });
      } else {
        externalApi.executeCommand("stopRecording", "file");
      }
      setStartMet(true);
    });
    externalApi.addEventListener("videoConferenceLeft", () => {
      //externalApi.executeCommand("hangup");
      setCurrentScreen("citaConcluido");
      setOpenencuesta(true);
    });

    //cuando cuelga
    externalApi.addEventListener("readyToClose", () => {
      setHangUp(true);
    });
  };

  const onCompleteTimeStart = () => {
    if (items.cita.scheduleDTO.scheduleType.id === "Online") {
      setCurrentScreen("enCita");
    }
  };

  const onComplete = () => {
    setTimeout(() => {
      setHangUp(true);
      setCurrentScreen("citaConcluido");
      setOpenencuesta(true);
    }, 1000);
  };

  const handleWait = async (espera) => {
    if (espera) {
      let secW = getTimeParam(items.cita.hourSettings.secondWait, "s");
      setOndemandWait2(secW - 10000);
      setItems((prev) => ({
        ...prev,
        waitMessage: "Espere a que su médico se conecte",
      }));
      setOndemandWait1(-2);
      setCurrentScreen("firstWait");
    } else {
      setCurrentScreen("loading");
      let data = {
        id: items.cita.id,
        appointmentStatus: "NoAtendida",
      };
      try {
        await Put({
          url: UPDATE_APPOINTMENT_SIN_TOKEN,
          data: data,
          header: false,
        });
        setCurrentScreen("autoagendarMiCita");
      } catch (error) {
        setCurrentScreen("errorComunication");
      }
    }
  };

  const demandMedicoNoConectado = () => {
    const content = (
      <div>
        <p className="m-0 py-2">El médico no puede conectarse</p>
        <button onClick={(e) => handleWait(false)}>Programar cita</button>
      </div>
    );
    return <CardDinamic children={content}></CardDinamic>;
  };

  const changeLegalWarning = async (dataToSend) => {
    try {
      const responseCita = await Put({
        url: UPDATE_APPOINTMENT_SIN_TOKEN,
        data: dataToSend,
        header: false,
      });
      setItems((prev) => ({
        ...prev,
        legalWarning: responseCita.data.data.legalWarnings[0],
      }));
      setRecheck(true);
      setItems((prev) => ({
        ...prev,
        isProcessRequest: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handleDeclinarAppointment = async () => {
    try {
      setItems((prev) => ({
        ...prev,
        isProcessRequest: true,
      }));
      const responseIp = await getIpPublic();
      let data = {
        id: items.cita.id,
        legalWarnings: [
          {
            id: items.legalWarning.id,
            acceptPatient: "declined",
            ipAddress: responseIp,
            legalWarningType: "InformedConsent",
            dataRecord: content,
          },
        ],
      };
      const responseCita = await Put({
        url: UPDATE_APPOINTMENT_SIN_TOKEN,
        data: data,
        header: false,
      });
      setItems((prev) => ({
        ...prev,
        cita: {
          ...prev.cita,
          appointmentStatus: responseCita.data.data.appointmentStatus,
        },
        legalWarning: responseCita.data.data.legalWarnings[0],
        isProcessRequest: false,
      }));
      setRecheck(true);
    } catch (error) {
      console.log(error);
    }
  };

  const screens = {
    loading: (
      <div className="p-5 text-center">
        <Loading />
      </div>
    ),
    notFoundAppointment: (
      <CardDinamic children={notFoundAppointment}></CardDinamic>
    ),
    errorComunication: <CardDinamic children={errorComunication}></CardDinamic>,
    statusCita: <CardDinamic children={statusCita(items.statusMessage)} />,
    firstWait: <WaitOnDemandV2 secondStep={false} title={items.waitMessage} />,
    secondWait: <WaitOnDemandV2 secondStep={true} />,
    demandMedicoNoConectado: demandMedicoNoConectado,
    citaConcluido: <OnCitaConcluidov2 cita={items.cita} />,
    citaNoComienza: (
      <OnCitaNoComienzaV2
        items={items}
        onCompleteTimeStart={onCompleteTimeStart}
      />
    ),
    citaNoComienzaDiferentDay: (
      <OnCitaNoComienzaDiferentDayV2 cita={items.cita} />
    ),
    enCita: (
      <OnCitaV2
        onApiReady={onApiReady}
        cita={items.cita}
        onComplete={onComplete}
      />
    ),
    autoagendarMiCita: (
      <AutoagendamientoOnDemandV2
        cita={items.cita}
        onDemand={true}
        source={"autoagendamientoapp"}
      />
    ),
    declinadoLegalWarning: (
      <CardDinamic children={declinadoLegalWarning}></CardDinamic>
    ),
    pendingLegalWarning: (
      <PendiengLegalWarningV2
        items={items}
        setItems={setItems}
        onHandleChangeLegalWarning={changeLegalWarning}
        setContent={setContent}
      />
    ),
  };

  return (
    <ThemeProvider theme={theme}>
      <AutoagendamientoV2Styles />
      <div className="body-1">
        <HeaderTop company={items?.cita?.account?.company} />
        {currentScreen === "citaNoComienza" && <Banner1 />}
        <main>{screens[currentScreen]}</main>
        <AutoagendmientoFooter cita={items.cita} />
      </div>
      <SurveyV2
        open={openEncuesta}
        setOpen={setOpenencuesta}
        setCurrentScreen={setCurrentScreen}
        cita={items.cita}
        company={{ id: 2 }}
      />
      {/*modal consentimiento declinado*/}
      <Modal
        show={items.openConfirmacionDeclinar}
        onHide={() =>
          setItems((prev) => ({ ...prev, openConfirmacionDeclinar: false }))
        }
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Body className="position-relative overflow-hidden">
          <h5 className="text-center mb-5 colorLabel">
            ¿Usted está seguro desea rechazar su consentimiento informado? Al
            seleccionar Si, no se podrá continuar con su atención médica?
          </h5>
          <Row className="text-center">
            {items.isProcessRequest ? (
              <Col className="text-center">
                <Loading />
              </Col>
            ) : (
              <Col>
                <button
                  onClick={() =>
                    setItems((prev) => ({
                      ...prev,
                      openConfirmacionDeclinar: false,
                    }))
                  }
                >
                  No
                </button>{" "}
                <button
                  onClick={() => {
                    setItems((prev) => ({
                      ...prev,
                      openConfirmacionDeclinar: false,
                    }));
                    handleDeclinarAppointment();
                  }}
                >
                  Si
                </button>
              </Col>
            )}
          </Row>
        </Modal.Body>
      </Modal>
    </ThemeProvider>
  );
}

export default ClbConferencia;

const notFoundAppointment = (
  <div>
    <p className="m-0 py-2">Lo sentimos, esta url no es válida</p>
  </div>
);
const errorComunication = (
  <div>
    <p>Sr(a). Usuario: En estos momentos no podemos procesar su cita.</p>
    <button onClick={() => window.location.reload()}>Volver a intentar</button>
  </div>
);
const statusCita = (message) => (
  <div>
    <p className="m-0 py-2 text-center">{message}</p>
  </div>
);
const declinadoLegalWarning = (
  <div>
    <p className="m-0 py-2">
      Usted ha declinado el{" "}
      <strong>CONSENTIMIENTO INFORMADO PARA EL SERVICIO DE TELESALUD </strong>
      por lo que no puede acceder a dicha cita. Si desea agendar nueva cita por
      favor realizar nuevamente su proceso de agendamiento.
    </p>
  </div>
);
